import { createSelector } from "reselect";
import { isEmpty } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const profile = state.user.profile;

  if (isEmpty(profile)) {
    return undefined;
  }

  if (profile.profileVisitors) {
    return profile.profileVisitors;
  } else {
    return undefined;
  }
};
//VERIFY IF THE JWT IS SET
const getMyProfileVisitorsCount = createSelector(getData, count => count);
export default getMyProfileVisitorsCount;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getMyProfileVisitorsCount.js